import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { MobileVehicleRelocationPhotosService } from 'src/app/services/mobile/mobile-vehicle-relocation-photos.service';
import { ToastrService } from 'ngx-toastr';
import { Location } from '@angular/common';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-re-upload-vehicle-transfer-photos',
  templateUrl: './re-upload-vehicle-transfer-photos.component.html',
  styleUrls: ['./re-upload-vehicle-transfer-photos.component.css']
})
export class ReUploadVehicleTransferPhotosComponent implements OnInit{
  public isLoading: boolean = false;
  photos: any[] = [];
  public chassis_no: string | null = null;
  public log_id: string = '';
  public txn_type: string = '';
    public isUploading: boolean = false;
    form!: FormGroup;
    files: File[] = [];
    attachment: any;

  constructor(
    private activatedRoute:ActivatedRoute,
    private vehicleRelocationPhotosService:MobileVehicleRelocationPhotosService,
    private toastr: ToastrService,
    private location: Location,
    private router: Router,
     private formBuilder: FormBuilder
  ){
    this.form = this.formBuilder.group({
      attachment: [null, Validators.required],
    });
  }

  ngOnInit(): void {
    this.activatedRoute.paramMap.subscribe((param: Params)=>{
      this.chassis_no = param['get']('chassis_no')
      this.log_id = param['get']('log_id')
      this.txn_type = param['get']('txn_type')
    })

    if(this.chassis_no && this.log_id && this.txn_type){
      this.isLoading=true;

      if(this.txn_type=='transfer' ||this.txn_type=='road_test' || this.txn_type=='service' || this.txn_type=='delivery'){
        this.getVehicleTransferringPhotos(this.log_id);
      }else{
        this.getVehicleReceivingPhotos(this.log_id);
      }

    }else{
      let errorMessage="Oops! A problem was encountered while processing your request. Please refresh the page and try again!";
      this.toastr.error(errorMessage, 'Error!');
    }
  }

  /**
   * Get vehicle transfer photos
   * @param vehicle_id
   */
  getVehicleTransferringPhotos(log_id: string):void
  {
     this.isLoading=true;

     this.vehicleRelocationPhotosService.getVehicleTransferringPhotos(log_id)
     .subscribe({
       next: (response) => {
         if(response.status==='success'){
           this.isLoading=false;
           this.photos = response.data;
         }else if(response.status==='no_data'){
           this.isLoading=false;
           this.toastr.warning(response.message, 'Warning!');
         }else{
           this.isLoading=false;
           let errorMessage="Unable to load vehicle transfer photos. Please refresh the page and try again!";
           this.toastr.error(errorMessage, 'Error!');
         }
       },
       error: (error) => {
         this.isLoading=false;
         this.toastr.error(error, 'Error!');
       }
     });
   }

   /**
   * Get vehicle receiving photos
   * @param vehicle_id
   */
   getVehicleReceivingPhotos(log_id: string):void
   {
     this.isLoading=true;

     this.vehicleRelocationPhotosService.getVehicleReceivingPhotos(log_id)
     .subscribe({
       next: (response) => {
         if(response.status==='success'){
           this.isLoading=false;
           this.photos = response.data;
         }else if(response.status==='no_data'){
           this.isLoading=false;
           this.toastr.warning(response.message, 'Warning!');
         }else{
           this.isLoading=false;
           let errorMessage="Unable to load vehicle receiving photos. Please refresh the page and try again!";
           this.toastr.error(errorMessage, 'Error!');
         }
       },
       error: (error) => {
         this.isLoading=false;
         this.toastr.error(error, 'Error!');
       }
     });
   }

  goBack(): void {
    this.location.back();
  }

  //Select image
  onSelect(event: any) {
    this.files.push(...event.addedFiles);
  }

  //Remove image
  onRemove(event: any) {
    this.files.splice(this.files.indexOf(event), 1);
  }

  /**
    * Upload vehicle photos
    */
  handleSubmit(){
    if(this.files.length===0){
      this.toastr.error("Please select photos to proceed!", 'Error!');
    }else{
      this.isUploading=true;

      const formData = new FormData();
      this.files.forEach(file => {
        formData.append('photos[]', file);
      });

      this.vehicleRelocationPhotosService.uploadPhotos(formData,this.chassis_no,this.log_id,this.txn_type)
       .subscribe({
         next: (response) => {
           if(response.status==='success'){
             this.isUploading=false;
             this.toastr.success(response.message, 'Upload Successful!');

             //Cleared selected images
             this.files=[];

             //Redirect to recent transfers list
             this.router.navigate(['mobile/recent-transfers']);
           }else{
             this.isUploading=false;
             this.toastr.error(response.message, 'Error!!');
           }
         },
         error: (error) => {
           this.isUploading=false;
           this.toastr.error(error, 'Error!');
         }
       });
    }
  }
}
